import {
    ShoppingPathJointReportReasonValueObject
} from "../../../../model/vo/content/ShoppingPathJointReportReasonValueObject";
import {ShoppingPathJointReportReasonIO} from "../../../../io/content/ShoppingPathJointReportReasonIO";
import {ListPage} from "../../common/ListPage";
import {RouteContext} from "../../../RouteContext";
import {Column} from "../../common/Layout";


export default function List(props: RouteContext) {

    return <>
        <Column gap={'16px'}>
            <ListPage
                {...props}
                description={ShoppingPathJointReportReasonValueObject.description}
                list={ShoppingPathJointReportReasonIO.list}
                count={ShoppingPathJointReportReasonIO.count}
                delete={ShoppingPathJointReportReasonIO.delete}
                postHref={'/admin/shoppings/pathJointReportReasons/post'}
                detailHref={item => `/admin/shoppings/pathJointReportReasons/${item.id}`}
                editHref={item => `/admin/shoppings/pathJointReportReasons/edit/${item.id}`}
            />
        </Column>
    </>
}